import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/components/sections/SourcesSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/app/[locale]/staff-shortage-hospitality/StaffShortagePage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
